import React, { useEffect } from 'react';

const PrivacyPolicy = () => {


    useEffect(() => {
        document.title = "Document Repository | Privacy Policy";
    }, [window.location.pathname])

    const containerStyle = {
        maxWidth: '800px',
        margin: '20px auto',
        padding: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
        color: '#333',
        height: "calc(100vh - 50px)",  // height of the container
        minHeight: '500px',  // minimum height to ensure scrolling when content overflows
        overflow: "auto"
    };


    const headingStyle = {
        borderBottom: '2px solid #eee',
        paddingBottom: '10px',
    };

    return (
        <div className='privacy_policy' style={containerStyle}>
            <h1 style={headingStyle}>Welcome to the My Digital Library</h1>
            <p>By accessing or using this service, you agree to abide by the following terms and conditions:</p>

            <h3 style={headingStyle}>1. <strong>Acceptance of Terms</strong></h3>
            <ul>
                <li>By accessing this digital library, you agree to follow these terms and all applicable laws and regulations.</li>
            </ul>

            <h3 style={headingStyle}>2. <strong>User Registration</strong></h3>
            <ul>
                <li>Access to certain content may require registration. You are responsible for maintaining the confidentiality of your account details.</li>
                <li>You agree to provide accurate and complete information during the registration process and to update it as needed.</li>
            </ul>

            <h3 style={headingStyle}>3. <strong>Permitted Use</strong></h3>
            <ul>
                <li>The digital library materials are for personal, educational, or non-commercial use only.</li>
                <li>You may not copy, redistribute, or share materials outside of the digital library platform unless explicitly permitted.</li>
            </ul>

            <h3 style={headingStyle}>4. <strong>Content Ownership and Copyright</strong></h3>
            <ul>
                <li>All digital content, including texts, images, and other resources, are protected by copyright and owned by the library or licensed providers.</li>
                <li>Unauthorized reproduction or distribution of content is prohibited and may result in termination of access and legal action.</li>
            </ul>

            <h3 style={headingStyle}>5. <strong>User Conduct</strong></h3>
            <ul>
                <li>You agree to use the digital library in a respectful and lawful manner. Any form of abuse, harassment, or attempt to hack, alter, or damage the library platform is prohibited.</li>
            </ul>

            <h3 style={headingStyle}>6. <strong>Privacy Policy</strong></h3>
            <ul>
                <li>We respect your privacy. Please refer to our Privacy Policy to understand how we collect, use, and protect your personal data.</li>
            </ul>

            <h3 style={headingStyle}>7. <strong>Limitation of Liability</strong></h3>
            <ul>
                <li>The digital library and its content are provided on an "as-is" basis. We make no guarantees about the accuracy, completeness, or suitability of materials.</li>
                <li>We are not liable for any damages arising from the use or inability to use the library, including data loss or security issues.</li>
            </ul>

            <h3 style={headingStyle}>8. <strong>Content Removal or Modification</strong></h3>
            <ul>
                <li>We reserve the right to modify, suspend, or remove any content within the digital library at our discretion, with or without prior notice.</li>
            </ul>

            <h3 style={headingStyle}>9. <strong>Termination of Access</strong></h3>
            <ul>
                <li>We may suspend or terminate access to the digital library if these terms are violated.</li>
            </ul>

            <h3 style={headingStyle}>10. <strong>Amendments</strong></h3>
            <ul>
                <li>We may update these terms periodically. Continued use of the digital library after updates implies acceptance of the revised terms.</li>
            </ul>

            <h3 style={headingStyle}>11. <strong>Governing Law</strong></h3>
            <ul>
                <li>These terms are governed by the laws of the United States</li>
            </ul>

            <p>For any questions regarding these terms, please contact us.</p>
        </div>

    );
};

export default PrivacyPolicy;
